export const CONDITIONS = ["NM", "LP", "MP", "HP", "DMG"];

export const CONDITION_GUIDE = [
  {
    code: "NM",
    name: "Near Mint",
    description:
      "0–3 small whitening spots on edges. No creases, bends, or major surface scratches.",
  },
  {
    code: "LP",
    name: "Lightly Played",
    description:
      "Light edge whitening (more than 3 spots or light wear along edges). Minor surface scuffs visible on close inspection.",
  },
  {
    code: "MP",
    name: "Moderately Played",
    description:
      "Noticeable edge whitening and wear on multiple edges. Visible scratches, print lines, or slight corner rounding.",
  },
  {
    code: "HP",
    name: "Heavily Played",
    description:
      "Heavy edge whitening and corner wear. Multiple surface scratches, scuffs, or minor creasing that does not break the card.",
  },
  {
    code: "DMG",
    name: "Damaged",
    description:
      "Major flaws — creases, bends, tears, water damage, ink marks, or heavy warping.",
  },
];

export function getConditionGuide(code) {
  return CONDITION_GUIDE.find((entry) => entry.code === code);
}
